import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_97: FaireProductEntity = {
  token: "legacy_prod_abbott-97",
  type: "product",
  name: 'Butterfly Edged Planter 7" H',
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/5b643ca5b1d4b6e1684ec8ee6a261ea71040590653c7a52e968dcb6387fc6ce7.jpeg",
  priceDollars: 28,
  subcategory: "Planters",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_garden-outdoor"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
